<template>
  <div>
    <v-data-table
      :headers="headers"
      :items="projetos.content"
      class="elevation-1 mt-5 rounded-card"
      :loading="loading"
      :server-items-length="projetos.total"
      @update:options="updateOptions"
      :footer-props="footerOptions"
      no-data-text="Nenhum projeto encontrada"
      loading-text="Carregando projetos..."
      :options="optionsList"
    >
      <template v-slot:item.codigoInterno="{ item }">
        {{ item.codigoInterno | naoInformado }}
      </template>
      <template v-slot:item.descricao="{ item }">
        {{ item.descricao | naoInformado }}
      </template>
      <template v-slot:item.ativo="{ item }">
        <px-ativo :ativo="item.ativo"/>
      </template>
      <template v-slot:item.options="{ item }" v-if="hasRoleComprador">
        <div class="text-right">
          <v-btn icon
                @click="goToEditProjeto(item)">
            <v-icon>mdi-pencil</v-icon>
          </v-btn>
          <v-btn icon
                @click="onClickDelete(item)">
            <v-icon>mdi-delete</v-icon>
          </v-btn>
        </div>
      </template>
    </v-data-table>
    <px-confirm-dialog ref="confirm"/>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  props: {
    projetos: Object,
    default: [],
    loading: Boolean,
    onChangeOptions: {
      type: Function,
      required: true,
    },
    optionsList: Object,
    footerOptions: Object,
  },
  computed: {
    ...mapGetters('user', ['hasRoleComprador']),
  },
  data() {
    return {
      headers: [
        {
          text: 'Código',
          value: 'codigoInterno',
        },
        {
          text: 'Descrição',
          value: 'descricao',
        },
        {
          text: 'Situação',
          value: 'ativo',
        },
        {
          text: null,
          sortable: false,
          value: 'options',
        },
      ],
    };
  },
  methods: {
    updateOptions(options) {
      this.onChangeOptions(options);
    },
    remove(item) {
      this.$emit('remove', item);
    },
    goToEditProjeto(item) {
      this.$router.push({
        name: 'main.projetos.edicao',
        params: {
          id: item.id,
        },
      });
    },
    onClickDelete(item) {
      this.$refs.confirm.open('Você deseja remover este projeto?',
        'O projeto será removido e esta operação não pode ser desfeita.',
        { width: 450 })
        .then((confirm) => {
          if (!confirm) {
            return;
          }
          this.remove(item);
        });
    },
  },
};
</script>
